<template>
    <div
        class="flex flex-col justify-start w-screen pt-5 pb-4 mx-auto mt-6 md:w-full md:max-w-3xl lg:max-w-3xl bg-slate-50 md:rounded-lg md:pt-8 md:pb-5 md:px-6 lg:mt-8"
    >
        <div class="flex flex-row justify-between px-6 md:px-0 mb-6">
            <h3 v-text="t('show.section_articles_highlight')"></h3>
            <div
                v-if="articles.length > 1"
                class="flex flex-row"
            >
                <i
                    class="w-6 h-6 icon icon-chevron-circled-left bg-slate-300"
                    data-click="news & events carousel, previous"
                    @click="$refs.articlesCarousel.goToPrev()"
                ></i>
                <i
                    class="w-6 h-6 icon icon-chevron-circled-right bg-slate-300"
                    data-click="news & events carousel, next"
                    @click="$refs.articlesCarousel.goToNext()"
                ></i>
            </div>
        </div>
        <VueAgile
            ref="articlesCarousel"
            :options="optionsCarousel"
            class=""
        >
            <div
                v-for="article in articles"
                :key="article._id"
                class="flex flex-col items-start self-stretch justify-start h-full slide py-1 max-md:container md:px-1"
            >
                <div class="flex flex-col self-stretch h-full rounded-lg bg-white shadow md:mr-5">
                    <div class="relative p-4">
                        <div
                            :style="articlePoster(article.poster)"
                            class="bg-center bg-cover w-full article-banner border border-solid border-slate-100"
                            :data-click="`news & events,${article.title}`"
                        ></div>
                    </div>
                    <div class="flex flex-col w-full px-4 pb-5 h-full article-content justify-between md:pb-6 lg:pb-8">
                        <div>
                            <h4
                                class="break-words mb-3 text-base leading-normal line-clamp-2 text-black md:text-lg"
                                v-text="article.title"
                            ></h4>
                            <p
                                v-if="article.description"
                                class="break-words text-xs font-normal line-clamp-3 leading-normal text-slate-600 md:text-base"
                                v-text="article.description"
                            ></p>
                            <p
                                v-if="article.eventDate"
                                class="flex flex-row items-center mt-5 md:mt-7 text-xs md:text-sm"
                            >
                                <i class="w-5 h-5 mr-2 icon icon-calendar text-slate-600 flex-shrink-0"></i>
                                <span>
                                    <span class="whitespace-nowrap">
                                        {{ formattedEventDate(article.eventDate, !article.allDay) }}
                                    </span>
                                    <span v-if="article.eventEndDate">
                                        -
                                        <span class="whitespace-nowrap">
                                            {{ formattedEventDate(article.eventEndDate, !article.allDay) }}
                                        </span>
                                    </span>
                                </span>
                            </p>
                        </div>
                        <BtnCta
                            v-if="article.url"
                            :data-click="`news & events,${article.url}`"
                            :href="article.url"
                            target="_blank"
                            content-color="white"
                            class="btn-link w-full line-clamp-1 mt-3 md:mt-5"
                            :label="article.eventDate ? t('show.btn_event_label') : t('show.btn_article_label')"
                        />
                    </div>
                </div>
            </div>
        </VueAgile>
    </div>
</template>

<script>
import { VueAgile } from 'vue-agile';
import dayjs from 'dayjs';
import dayjsUTC from 'dayjs-plugin-utc';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'CompanyShowArticlesCarousel',
    components: {
        VueAgile,
    },
    props: {
        articles: {
            type: Array,
            required: true,
        },
    },
    setup() {
        const { t } = useTranslation('company');
        return { t };
    },
    data() {
        return {
            optionsCarousel: {
                centerMode: false,
                dots: false,
                infinite: true,
                navButtons: false,
                slidesToShow: 1,
                responsive: [
                    {
                        breakpoint: 320,
                        settings: {
                            centerMode: true,
                            slidesToShow: 1,
                            infinite: true,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            centerMode: true,
                            slidesToShow: 2,
                            infinite: false,
                        },
                    },
                ],
            },
        };
    },
    created() {
        dayjs.extend(dayjsUTC);
    },
    methods: {
        articlePoster(poster) {
            return poster && poster.asset && poster.asset.url
                ? { 'background-image': `url( ${poster.asset.url})` }
                : {
                      'background-image': `url(/images/opengraph/sharing-default@3x.png)`,
                  };
        },
        formattedEventDate(eventDate, showTime = true) {
            const localDate = dayjs(eventDate).utc().local();
            const format = showTime ? this.t('show.event_date_time_format') : this.t('show.event_date_format');

            return localDate.format(format);
        },
    },
};
</script>
<style lang="scss" scoped>
.article-banner {
    height: 9.5rem;
    @screen md {
        height: 10.75rem;
    }
}
.break-words {
    word-break: break-word !important;
}
</style>
